import React, { lazy } from 'react'
import { FrontUrls } from 'Constants/FrontUrls'
import { LazyRoute } from 'Modules'

const PreloginLazy = lazy(() => import('Pages/prelogin/components/Main'))

export const PreloginRoutes = <LazyRoute path={FrontUrls.prelogin} lazyComponent={PreloginLazy} />
